// src/app/components/flashOffer/useFlashOffer.js
import { useCallback, useEffect, useState } from "react";
import { fetchFlashOffers } from "./flashOfferService";

const isPast = (value) => {
  const time = new Date(value).getTime();
  return Number.isNaN(time) || time <= Date.now();
};

const NO_OFFERS = Object.freeze([]);

/**
 * Ventes flash en cours.
 *
 * `offers` est vide tant que rien n'est chargé, s'il n'y a pas de vente, si
 * l'appel échoue, ou si toutes les ventes sont terminées : dans tous ces cas
 * la page n'affiche simplement pas la section. Un bloc promotionnel ne doit
 * jamais afficher d'erreur ni de squelette sur la page d'accueil.
 */
export default function useFlashOffer() {
  const [offers, setOffers] = useState(NO_OFFERS);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const controller = new AbortController();

    fetchFlashOffers({ signal: controller.signal })
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setOffers(list.filter((offer) => offer?.endsAt && !isPast(offer.endsAt)));
        setStatus("ready");
      })
      .catch((error) => {
        if (error?.name === "AbortError") return;
        // eslint-disable-next-line no-console
        console.warn("[flashOffer] chargement impossible", error);
        setOffers(NO_OFFERS);
        setStatus("error");
      });

    return () => controller.abort();
  }, []);

  /* Appelé à l'échéance d'une vente : elle est retirée de la liste. */
  const expire = useCallback((id) => {
    setOffers((prev) => prev.filter((offer) => offer.id !== id));
  }, []);

  return { offers, status, expire };
}
